import { render, staticRenderFns } from "./SubFolderDocumentType.vue?vue&type=template&id=e7b7482a&scoped=true&"
import script from "./SubFolderDocumentType.vue?vue&type=script&lang=js&"
export * from "./SubFolderDocumentType.vue?vue&type=script&lang=js&"
import style0 from "./SubFolderDocumentType.vue?vue&type=style&index=0&id=e7b7482a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b7482a",
  null
  
)

export default component.exports